export const debounce = <F extends (...args: unknown[]) => void>(func: F, delay: number) => {
	let timeoutId: string | number | NodeJS.Timeout | undefined

	return (...args: Parameters<F>): void => {
		if (timeoutId) {
			clearTimeout(timeoutId)
		}

		timeoutId = setTimeout(() => {
			func(...args)
		}, delay)
	}
}
